import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _capitalize from "lodash/capitalize";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import classnames from 'classnames';
import { CardGrid } from "../../Grid/CardGrid/CardGrid";
import { Container } from "../../Container/Container/Container";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { LargeCard } from "../../Card/LargeCard/LargeCard";
import { Button, buttonTypes } from "../../Button/Button/Button";
import { Pagination, defaultPropsPagination } from "../../Navigation/Pagination/Pagination";
import { Background } from "../../Background/Background";
import { Text } from "../../Text/Text/Text";
import styles from "./CardGridSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var cardGridSliceAlign = ['left', 'center'];
export var CardGridSliceButtonTypes = buttonTypes;
export var CardGridSlice = function CardGridSlice(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'content' : _ref$type,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'center' : _ref$align,
    button = _ref.button,
    cardList = _ref.cardList,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? {
      text: '',
      typog: 'headline4',
      variant: 'accent'
    } : _ref$heading,
    largeCard = _ref.largeCard,
    _ref$pagination = _ref.pagination,
    pagination = _ref$pagination === void 0 ? _objectSpread({}, defaultPropsPagination) : _ref$pagination,
    _ref$subTitle = _ref.subTitle,
    subTitle = _ref$subTitle === void 0 ? '' : _ref$subTitle,
    background = _ref.background;
  var fallbackImages = {
    content: 'https://v.cdn.ww.com/media/system/cms/us/no-image-content.png',
    food: 'https://v.cdn.ww.com/media/system/cms/us/no-image-food.png'
  };
  var gridAlignment = align === 'center' ? 'center' : 'start';
  var headerAlignClassname = styles["cardGridHeaderAlign".concat(_capitalize(align))];
  var subAlignClassname = styles["cardGridSubTitleAlign".concat(_capitalize(align))];
  var buttonAlignClassname = styles["cardGridButtonAlign".concat(_capitalize(align))];
  return /*#__PURE__*/_jsx(Background, _objectSpread(_objectSpread({}, background), {}, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx("div", {
        className: styles.cardGrid,
        children: /*#__PURE__*/_jsx("div", {
          className: styles.cardGridWrapper,
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.cardGridContent,
            children: [((heading === null || heading === void 0 ? void 0 : heading.text) || subTitle) && /*#__PURE__*/_jsxs("div", {
              className: classnames(styles.cardGridHeader, headerAlignClassname),
              children: [(heading === null || heading === void 0 ? void 0 : heading.text) && /*#__PURE__*/_jsx(HeadingText, {
                className: styles.cardGridHeadline,
                align: align,
                ariaLevel: heading.ariaLevel,
                typog: heading.typog,
                variant: heading.variant,
                richText: true,
                children: heading.text
              }, "heading"), subTitle && /*#__PURE__*/_jsx(Text, {
                typog: "bodycopyLarge",
                className: classnames(styles.cardGridSubtitle, subAlignClassname),
                richText: true,
                children: subTitle
              }, "body")]
            }, "heading-wrapper"), largeCard && /*#__PURE__*/_jsx("div", {
              className: styles.cardGridLargeCard,
              children: /*#__PURE__*/_jsx(LargeCard, {
                image: largeCard.image || fallbackImages[type],
                link: largeCard.link,
                newWindow: largeCard.newWindow,
                subtitle: largeCard.subtitle,
                title: largeCard.title,
                personalPoints: largeCard.personalPoints,
                cardActionAttributes: largeCard.cardActionAttributes
              })
            }, "largecard-wrapper"), /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(CardGrid, {
                cardList: cardList,
                fallbackImage: fallbackImages[type],
                gridAlignment: gridAlignment
              }, "card-grid")
            }, "grid-wrapper"), (pagination === null || pagination === void 0 ? void 0 : pagination.pageUrl) && /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(Pagination, {
                pageUrl: pagination.pageUrl,
                activePage: pagination.activePage,
                totalPages: pagination.totalPages,
                labels: pagination.labels
              })
            }, "pagination-wrapper"), (button === null || button === void 0 ? void 0 : button.url) && (button === null || button === void 0 ? void 0 : button.text) && /*#__PURE__*/_jsx("div", {
              className: classnames(buttonAlignClassname, styles.cardGridCta),
              children: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, button), {}, {
                children: button.text
              }))
            }, "cta-wrapper")]
          })
        })
      })
    })
  }));
};